import request from '@/utils/request'


// 查询用户信息列表
export function listUser(query) {
  return request({
    url: '/biz/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户信息分页
export function pageUser(query) {
  return request({
    url: '/biz/user/page',
    method: 'get',
    params: query
  })
}

export function pageTopUser(query) {
  return request({
    url: '/biz/user/topPage',
    method: 'get',
    params: query
  })
}

export function pageClientUser(query) {
  return request({
    url: '/biz/user/pageClientUser',
    method: 'get',
    params: query
  })
}

export function queryUserCountByType(query) {
  return request({
    url: '/biz/user/queryUserCountByType',
    method: 'get',
    params: query
  })
}

export function querySourceChannelList() {
  return request({
    url: '/biz/user/querySourceChannelList',
    method: 'get'
  })
}

// 查询用户信息详细
export function getUser(data) {
  return request({
    url: '/biz/user/detail',
    method: 'get',
    params: data
  })
}

export function getCardDetails(data) {
  return request({
    url: '/biz/user/getCardDetails',
    method: 'get',
    params: data
  })
}

// 修改用户信息
export function updateUserCard(data) {
  return request({
    url: '/user/user-card/edit',
    method: 'post',
    data: data
  })
}

// 修改用户信息
export function updateOther(data) {
  return request({
    url: '/biz/user/updateOther',
    method: 'post',
    data: data
  })
}

export function queryBrowseListById(data) {
  return request({
    url: '/biz/user/queryBrowseListById',
    method: 'get',
    params: data
  })
}

export function queryBankListById(data) {
  return request({
    url: '/biz/user/queryBankListById',
    method: 'get',
    params: data
  })
}

export function queryApplyListById(data) {
  return request({
    url: '/biz/user/queryApplyListById',
    method: 'get',
    params: data
  })
}
export function queryCollectListById(data) {
  return request({
    url: '/biz/user/queryCollectListById',
    method: 'get',
    params: data
  })
}
export function queryReportListById(data) {
  return request({
    url: '/biz/user/queryReportListById',
    method: 'get',
    params: data
  })
}
// 新增用户信息
export function addUser(data) {
  return request({
    url: '/biz/user/add',
    method: 'post',
    data: data
  })
}

// 修改用户信息
export function updateUser(data) {
  return request({
    url: '/biz/user/edit',
    method: 'post',
    data: data
  })
}

// 删除用户信息
export function delUser(data) {
  return request({
    url: '/biz/user/delete',
    method: 'post',
    data: data
  })
}

export function addHighSeas(data) {
  return request({
    url: '/biz/user/addHighSeas',
    method: 'post',
    params: data
  })
}

export function batchAddHighSeas(data) {
  return request({
    url: '/biz/user/batchAddHighSeas',
    method: 'post',
    params: data
  })
}

export function workbenchDispose(data) {
  return request({
    url: '/biz/user/workbenchDispose',
    method: 'post',
    params: data
  })
}

export function immediateInterview(data) {
  return request({
    url: '/biz/user/immediateInterview',
    method: 'post',
    params: data
  })
}

export function highSeasReceive(data) {
  return request({
    url: '/biz/user/highSeasReceive',
    method: 'post',
    params: data
  })
}

export function addFollow(data) {
  return request({
    url: '/user/user-follow/add',
    method: 'post',
    data: data
  })
}

export function addReport(data) {
  return request({
    url: '/user/user-report/add',
    method: 'post',
    data: data
  })
}

export function queryOperator(data) {
  return request({
    url: '/biz/user/queryOperator',
    method: 'post',
    data: data
  })
}

export function queryFollowListById(data) {
  return request({
    url: '/user/user-follow/list',
    method: 'get',
    params: data
  })
}

export function listReportPost(data) {
  return request({
    url: '/biz/user/queryReportPostList',
    method: 'get',
    params: data
  })
}

export function queryUserByType(data) {
  return request({
    url: '/biz/user/queryUserByType',
    method: 'get',
    params: data
  })
}

export function uploadUser(data) {
  return request({
    url: '/biz/user/uploadUser',
    method: 'post',
    data: data
  })
}

export function uploadUpdateStatusUser(data) {
  return request({
    url: '/biz/user/uploadUpdateStatusUser',
    method: 'post',
    data: data
  })
}

export function setStatus(data) {
  return request({
    url: '/biz/user/updateUserStatus',
    method: 'post',
    params: data
  })
}

export function clientMigration(data) {
  return request({
    url: '/biz/user/clientMigration',
    method: 'post',
    params: data
  })
}

export function topReferralsChange(data) {
  return request({
    url: '/biz/user/topReferralsChange',
    method: 'post',
    params: data
  })
}

export function getHomeData(data) {
  return request({
    url: '/biz/user/getHomeData',
    method: 'get',
    params: data
  })
}


export function getHomeLineOneData(data) {
  return request({
    url: '/biz/user/getHomeLineOneData',
    method: 'get',
    params: data
  })
}

export function getHomeLineTwoData(data) {
  return request({
    url: '/biz/user/getHomeLineTwoData',
    method: 'get',
    params: data
  })
}

export function pageReferralsUser(data) {
  return request({
    url: '/biz/user/pageReferralsUser',
    method: 'get',
    params: data
  })
}
